import { PasskeyManager } from "@/components/commons/PasskeyManager";
import { InnerBox } from "@/components/elements/InnerBox";
import { ExternalLoginSection } from "@/features/user-setting/components/detail/ExternalLoginSection";
import { PasskeyTable } from "@/features/user-setting/components/detail/PasskeyTable";
import { PasswordResetSection } from "@/features/user-setting/components/detail/PasswordResetSection";
import { divider } from "@/theme/colors";
import { Divider, Stack } from "@mui/material";
import { FC } from "react";

type TSecuritySettingsSectionProps = {
  googleConnected?: boolean;
  googleEmail?: string | null;
  onDisconnectGoogle?: () => void;
  onLinkGoogle?: () => void;
};

export const SecuritySettingsSection: FC<TSecuritySettingsSectionProps> = ({
  googleConnected,
  googleEmail,
  onDisconnectGoogle,
  onLinkGoogle,
}) => {
  return (
    <InnerBox title="セキュリティ設定" padding="24px">
      <Stack gap="32px">
        <PasswordResetSection />
        <Divider sx={{ borderColor: divider.middle }} />
        <PasskeyManager embedded renderList={(props) => <PasskeyTable {...props} />} />
        <Divider sx={{ borderColor: divider.middle }} />
        <ExternalLoginSection
          connected={googleConnected}
          connectedEmail={googleEmail}
          onDisconnect={onDisconnectGoogle}
          onConnect={onLinkGoogle}
        />
      </Stack>
    </InnerBox>
  );
};
